
/** 残高種別コード */
export enum BalanceType {
  // 0:支払
  PAY = '0',
  // 1:買掛
  ACCPAY = '1',
  // 2:請求
  BILLING = '2',
  // 3:売掛
  ACCREC = '3'
}

/** 抽出拠点コード */
export enum ExtractionOrganizationDiv {
  // 0:管理
  MANAGEMENT = '0',
  // 1:請求
  BILLING = '1'
}



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/credit-export-condition-modal/credit-export-condition-modal.define.ts